import * as Actions from '../ActionTypes'
import {fetchWithTimeout} from '../../core/http'
import { metaLookup } from '../../util/misc';
import requests from '../../core/request'

const getActions = {
    request: {type: Actions.GET_METAS_REQUEST},
    success (metas) {
        return {
            type: Actions.GET_METAS_SUCCESS,
            payload: metas
        }
    }
}

const createActions = {
    request: {type: Actions.CREATE_META_REQUEST},
    success (createdMeta) {
        return {
            type: Actions.CREATE_META_SUCCESS,
            payload: createdMeta
        }
    },
    error (error) {
        return {
            type: Actions.CREATE_META_FAILURE,
            payload: error
        }
    }
}

const deleteActions = {
    request: {type: Actions.DELETE_META_REQUEST},
    success (deletedMetaId) {
        return {
            type: Actions.DELETE_META_SUCCESS,
            payload: deletedMetaId
        }
    },
    error (error) {
        return {
            type: Actions.DELETE_META_FAILURE,
            payload: error
        }
    }
}

const editActions = {
    request: {type: Actions.EDIT_META_REQUEST},
    success (updatedMeta) {
        return {
            type: Actions.EDIT_META_SUCCESS,
            payload: updatedMeta
        }
    },
    error (error) {
        return {
            type: Actions.EDIT_META_FAILURE,
            payload: error
        }
    }
}

export const util = {
    formatToMetaOptions(metas) {
        const result = {}
        const dict = metaLookup

        metas.forEach(meta => {
            if (!result[dict[meta.type]]) result[dict[meta.type]] = {}
            result[dict[meta.type]][meta.id] = meta.name
        })

        return result
    },

    formatToGroupedMetas(metas) {
        const result = {}
        const dict = metaLookup

        metas.forEach(meta => {
            if (!result[dict[meta.type]]) result[dict[meta.type]] = []
            result[dict[meta.type]].push(meta)
        })

        return result
    }
}

export const getMetas = function () {
    const {request, success} = getActions

    return dispatch => {
        dispatch(request)
        fetchWithTimeout(requests.meta.all)
            .then(json => dispatch(success(json.data)))
            .catch(err => {
                throw err
            })
    }
}

export const createMeta = function (meta, onSuccess) {
    const {request, success, error} = createActions

    return dispatch => {
        dispatch(request)
        fetchWithTimeout(requests.meta.create, meta)
            .then(json => {
                dispatch(success(json.data))
                if (onSuccess) onSuccess()
            })
            .catch(err => dispatch(error(err)))
    }
}

export const deleteMeta = function (metaId) {
    const {request, success, error} = deleteActions

    return dispatch => {
        dispatch(request)
        fetchWithTimeout(requests.meta.delete(metaId))
            .then(json => dispatch(success(json.data)))
            .catch(err => dispatch(error(err)))
    }
}

export const editMeta = function (metaId, updatedProps, onSuccess) {
    const {request, success, error} = editActions

    return dispatch => {
        dispatch(request)
        fetchWithTimeout(requests.meta.edit(metaId), updatedProps)
            .then(json => {
                dispatch(success(json.data))
                if (onSuccess) onSuccess()
            })
            .catch(err => dispatch(error(err)))
    }
}
